var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from "react";
import { getStorageValue, setStorageValue } from "./storage";
export default (key, initialState) => {
    const [isLoading, setLoading] = useState(true);
    const [value, setValue] = useState(initialState);
    // Read from storage
    useEffect(() => {
        setLoading(true);
        void (() => __awaiter(void 0, void 0, void 0, function* () {
            const stored = yield getStorageValue(key);
            if (stored !== null) {
                setValue(stored);
            }
            setLoading(false);
        }))();
    }, [key]);
    // Write to storage
    useEffect(() => {
        if (isLoading) {
            // Do not overwrite until read
            return;
        }
        void setStorageValue(key, value);
    }, [isLoading, key, value]);
    return [value, setValue, { isLoading }];
};
